import React from "react";

const SearchSvg = () => {
  return (
    <div>
      <svg
        version="1.1"
        id="lni_lni-search"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 64 64"
        className="process-svg"
      >
        <path
          fill="#1CCE7C"
          d="M60.1,49.5L49.8,39.2c-1.4-1.4-3.3-2.2-5.3-2.2c-1.2,0-2.4,0.3-3.4,0.8l-5.2-5.2c5.9-7.5,5.4-18.4-1.5-25.4
	C27-0.1,14.8-0.1,7.4,7.4c-7.5,7.5-7.5,19.6,0,27.1C11.1,38.1,16,40,20.9,40c4.2,0,8.4-1.4,11.8-4.1l5.2,5.2c-0.5,1-0.8,2.2-0.8,3.4
	c0,2,0.8,3.9,2.2,5.3l10.3,10.3c1.5,1.5,3.4,2.2,5.3,2.2c1.9,0,3.8-0.7,5.3-2.2C63,57.2,63,52.4,60.1,49.5z M10.5,31.2
	c-5.7-5.7-5.7-15,0-20.7c2.9-2.9,6.6-4.3,10.3-4.3c3.7,0,7.5,1.4,10.4,4.3c5.7,5.7,5.7,15,0,20.7C25.5,36.9,16.2,36.9,10.5,31.2z
	 M56.9,56.9L56.9,56.9c-1.1,1.1-3,1.2-4.2,0L42.4,46.6c-0.6-0.6-0.9-1.3-0.9-2.1c0-0.8,0.3-1.5,0.9-2.1s1.3-0.9,2.1-0.9
	c0.8,0,1.5,0.3,2.1,0.9l10.3,10.3C58,53.9,58,55.7,56.9,56.9z"
        />
      </svg>
    </div>
  );
};

export default SearchSvg;
